import { render, staticRenderFns } from "./DeviceModels.vue?vue&type=template&id=018c5284&scoped=true"
import script from "./DeviceModels.vue?vue&type=script&lang=js"
export * from "./DeviceModels.vue?vue&type=script&lang=js"
import style0 from "./DeviceModels.vue?vue&type=style&index=0&id=018c5284&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c5284",
  null
  
)

export default component.exports